import { initReactI18next } from "react-i18next";
import { use } from "i18next";

import en from "./en.json";
import nb from "./nb.json";

export function initI18n(language: string) {
  return use(initReactI18next).init({
    lng: language,
    fallbackLng: "en",
    debug: import.meta.env.I18_DEBUG === "true",
    resources: {
      nb: { translation: nb },
      en: { translation: en }
    },
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    }
  });
}
